import "./TooltipCustom.scss";
import { FaRegCircleQuestion  } from "react-icons/fa6";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import {
  Icon
} from "@mui/material";

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'var(--color-n-100)',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid var(--color-n-400)',
    borderLeft: '4px solid var(--color-n-400)',
    fontFamily: 'var(--font-text)'
  },
}));


type TooltipCustomProps = {
  contentHtml?: string;
  fontSize?: number;
  color?: string;
};
const TooltipCustom = ({
  contentHtml = "temp",
  fontSize = 16,
  color = "var(--color-n-900)"
}: TooltipCustomProps) => {
  return (
    <HtmlTooltip
      placement="top"
      title={
        <React.Fragment>
          <div dangerouslySetInnerHTML={{__html:contentHtml}} />
        </React.Fragment>
      }
    >
      <Icon sx={{ fontSize }}>
        <FaRegCircleQuestion color={color} />
      </Icon>
    </HtmlTooltip>
  );
};

export default TooltipCustom;
